module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-content"
  }, [(_vm.data && _vm.data.length) ? _c('ul', {
    staticClass: "default file-info"
  }, [_c('li', {
    staticClass: "render flex"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("附件：")]), _vm._v(" "), _c('div', {
    staticClass: "file"
  }, _vm._l((_vm.strToArr(_vm.data)), function(file, index) {
    return _c('div', {
      key: index,
      staticClass: "file-item flex"
    }, [_c('div', {
      staticClass: "icon",
      class: _vm.fileIcoPath(file)
    }), _vm._v(" "), _c('a', {
      staticClass: "file-name",
      attrs: {
        "href": _vm.getDownloadUrl(file.attachIndex, file.filename),
        "download": "",
        "getDownloadUrl": file.filename
      }
    }, [_vm._v("\n              " + _vm._s(_vm.formatFilename(file.filename)) + "\n              ")]), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "operate"
    }, [(_vm.isShowFile(file)) ? _c('a', {
      staticClass: "view",
      attrs: {
        "href": _vm.clickPreview(file),
        "target": "_blank"
      }
    }, [_vm._v("\n                预览\n                ")]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "download",
      attrs: {
        "href": _vm.getDownloadUrl(file.attachIndex, file.filename),
        "download": "",
        "target": "_blank"
      }
    }, [_vm._v("\n                下载\n                ")])])])
  }))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cbb19cce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/attachment-preview.vue
// module id = 1341
// module chunks = 82